import DealCardsPreview from "../Previews/checksome";
import PreviewDeal3 from "../Previews/Deal/PreviewDeal3/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";
import ShipDealPreview from "../Previews/Ship/DealCard/Preview";

export const CelebrationPackages = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipBannerPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 1,
      fields: [
        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },


        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

      ],
      preview: (activetab, cardData) => (
        <ShipDealPreview activetab={activetab} cardData={cardData} />
      ),
    },
    // {
    //   type: 3,
    //   fields: [
    //     {
    //       title: "English Note",
    //       key: "note",
    //       className: "col-lg-4",
    //       type: "html",
    //       required: false,
    //     },
    //     {
    //       title: "Simplified Chinese note",
    //       key: "simplified_chinese_note",
    //       className: "col-lg-4",
    //       type: "html",
    //       required: false,
    //     },
    //     {
    //       title: "Traditional Chinese note",
    //       key: "traditional_chinese_note",
    //       className: "col-lg-4",
    //       type: "html",
    //       required: false,
    //     },

    //   ],
    //   level1: [
    //     {
    //       title: "English Title",
    //       key: "title",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Simplified Chinese Title",
    //       key: "simplified_chinese_title",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Traditional Chinese Title",
    //       key: "traditional_chinese_title",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },

    //   ],
    //   level2: [
    //     {
    //       title: "Card Image",
    //       key: "image",
    //       className: "col-lg-12",
    //       placeholder: "Upload Card Image",
    //       type: "file",
    //       required: false,
    //     },
    //     {
    //       title: "English Title",
    //       key: "title",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Simplified Chinese Title",
    //       key: "simplified_chinese_title",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Traditional Chinese Title",
    //       key: "traditional_chinese_title",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },

    //     {
    //       title: "English Subtitle",
    //       key: "sub_title",
    //       className: "col-lg-4",
    //       type: "input",
    //     },
    //     {
    //       title: "Simplified Chinese Subtitle",
    //       key: "simplified_chinese_sub_title",
    //       className: "col-lg-4",
    //       type: "input",
    //     },
    //     {
    //       title: "Traditional Chinese Subtitle",
    //       key: "traditional_chinese_sub_title",
    //       className: "col-lg-4",
    //       type: "input",
    //     },

    //     {
    //       title: "English From Text",
    //       key: "from_text",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Simplified Chinese From Text",
    //       key: "simplified_chinese_from_text",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Traditional Chinese From Text",
    //       key: "traditional_chinese_from_text",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },

    //     {
    //       title: "Card Price",
    //       key: "card_price",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Simplified Chinese Card Price",
    //       key: "simplified_chinese_card_price",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },
    //     {
    //       title: "Traditional Chinese Card Price",
    //       key: "traditional_chinese_card_price",
    //       className: "col-lg-4",
    //       type: "input",
    //       required: false,
    //     },

    //     {
    //       title: "English Description",
    //       key: "description",
    //       className: "col-lg-4",
    //       type: "html",
    //       required: false,
    //     },
    //     {
    //       title: "Simplified Chinese Description",
    //       key: "simplified_chinese_description",
    //       className: "col-lg-4",
    //       type: "html",
    //       required: false,
    //     },
    //     {
    //       title: "Traditional Chinese Description",
    //       key: "traditional_chinese_description",
    //       className: "col-lg-4",
    //       type: "html",
    //       required: false,
    //     },

    //   ],
    //   preview: (activetab, cardData) => (
    //     <PreviewDeal3 activetab={activetab} cardData={cardData} />
    //   ),
    // },
    {
      type: 6,
      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "English subtitle",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese subtitle",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese subtitle",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa subtitle",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Heading Title",
          key: "heading_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Heading Title",
          key: "simplified_chinese_heading_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Heading Title",
          key: "traditional_chinese_heading_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Heading Title",
          key: "bahasa_heading_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "English Note",
          key: "note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese note",
          key: "simplified_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese note",
          key: "traditional_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa note",
          key: "bahasa_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
      ],
      level2: [
        // {
        //   title: "Show Description",
        //   key: "show_desc",
        //   className: "col-lg-6",
        //   type: "select",
        //   option: [
        //     {
        //       id: "yes",
        //       name: "Yes",
        //     },
        //     { id: "no", name: "No" },
        //   ],
        // },
        // {
        //   title: "Show Menu",
        //   key: "show_menu",
        //   className: "col-lg-6",
        //   type: "select",
        //   option: [
        //     {
        //       id: "yes",
        //       name: "Yes",
        //     },
        //     { id: "no", name: "No" },
        //   ],
        // },
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        // {
        //   title: "English Description",
        //   key: "description",
        //   className: "col-lg-4",
        //   type: "html",
        // },
        // {
        //   title: "Simplified Chinese Description",
        //   key: "simplified_chinese_description",
        //   className: "col-lg-4",
        //   type: "html",
        // },
        // {
        //   title: "Traditional Chinese Description",
        //   key: "traditional_chinese_description",
        //   className: "col-lg-4",
        //   type: "html",
        // },
      ],
      level3: [{
        title: "Card Image",
        key: "image",
        className: "col-lg-12",
        placeholder: "Upload Card Image",
        type: "file",
        withAlt: true,
        required: false,
      },
      {
        title: "English Title",
        key: "title",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Simplified Chinese Title",
        key: "simplified_chinese_title",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Traditional Chinese Title",
        key: "traditional_chinese_title",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Bahasa Title",
        key: "bahasa_title",
        className: "col-lg-3",
        type: "input",
        required: false,
      },

      {
        title: "English Subtitle",
        key: "sub_title",
        className: "col-lg-3",
        type: "input",
      },
      {
        title: "Simplified Chinese Subtitle",
        key: "simplified_chinese_sub_title",
        className: "col-lg-3",
        type: "input",
      },
      {
        title: "Traditional Chinese Subtitle",
        key: "traditional_chinese_sub_title",
        className: "col-lg-3",
        type: "input",
      },
      {
        title: "Bahasa Subtitle",
        key: "bahasa_sub_title",
        className: "col-lg-3",
        type: "input",
      },

      {
        title: "English From Text",
        key: "from_text",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Simplified Chinese From Text",
        key: "simplified_chinese_from_text",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Traditional Chinese From Text",
        key: "traditional_chinese_from_text",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Bahasa From Text",
        key: "bahasa_from_text",
        className: "col-lg-3",
        type: "input",
        required: false,
      },

      {
        title: "Card Price",
        key: "card_price",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Simplified Chinese Card Price",
        key: "simplified_chinese_card_price",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Traditional Chinese Card Price",
        key: "traditional_chinese_card_price",
        className: "col-lg-3",
        type: "input",
        required: false,
      },
      {
        title: "Bahasa Card Price",
        key: "bahasa_card_price",
        className: "col-lg-3",
        type: "input",
        required: false,
      },

      {
        title: "English Description",
        key: "description",
        className: "col-lg-3",
        type: "html",
        required: false,
      },
      {
        title: "Simplified Chinese Description",
        key: "simplified_chinese_description",
        className: "col-lg-3",
        type: "html",
        required: false,
      },
      {
        title: "Traditional Chinese Description",
        key: "traditional_chinese_description",
        className: "col-lg-3",
        type: "html",
        required: false,
      },
      {
        title: "Bahasa Description",
        key: "bahasa_description",
        className: "col-lg-3",
        type: "html",
        required: false,
      }],
      preview: (activetab, cardData) => (
        <DealCardsPreview activetab={activetab} cardData={cardData} />
      )
    },
  ],
};
